<template>
  <div class="xt-area-wrap">
    <!-- <table>
        <tr>
          <th>省份</th>
        </tr>
        <tr v-for="(province,index) in data" :key="index">
          <td @click="getId(province.id)">{{province.name}}</td>
        </tr>
      </table> -->
    <div v-if="delayShow" style="display:flex;">
    <div class="provinces">
        <!-- <input type="radio" name="province" id="city0" @click="toggleAll"/>
        <label for="city0">{{provinceName}}</label>
        <span>></span> -->
        <Checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @click.prevent.native="handleCheckAll">{{provinceName}}</Checkbox>
    </div>
    <div class="citys">
        <CheckboxGroup v-model="selectedCityList" @on-change="checkAllGroupChange_city">
          <Checkbox v-for="(city,index) in cityList" :key="index"
            :label="city.name"
            :indeterminate="indeterminateDivide[index]"
            :value="checkAllDivide[index]"
            @click.native="handleCheckAllCity($event, index)"
          ></Checkbox>
        </CheckboxGroup>
        <!-- <div class="city" v-for="(value, key, index) in cityList" :key="key">
            <input type="checkbox" name="city" :id="'city'+ index" :data-id="key" :data-value="value"  @change="cityListUpdated($event)"/>
            <label :for="'city'+ index">{{value}}</label>
            <span>></span>
        </div> -->
    </div>
    <div class="divides">
        <CheckboxGroup v-model="selectedDivideList" @on-change="checkAllGroupChange_divide" >
          <Checkbox v-for="(divide,index) in divideList" :key="index" 
            :label="divide.name"
            :value="checkAllhhhh[index]"
            @click.native="handleCheckAllDivide($event, index)"
            ref="divides"
            ></Checkbox>
        </CheckboxGroup>
        <!-- <div class="divide" v-for="(value, key, index) in divideList" :key="key">
            <input type="checkbox" name="divide" :id="'divide'+ index" :data-id="key" :data-value="value"  @change="divideListUpdated($event)"/>
            <label :for="'divide'+ index">{{value}}</label>
        </div> -->
    </div>
    </div>
  </div>
</template>

<script>
import { CheckboxGroup, Checkbox } from "iview";
import 'iview/dist/styles/iview.css'
import axios from 'axios'
const URL = 'http://47.98.160.249:3266/platform/platmanager/cityManage/province/detail.htm?id='
export default {
  data() {
    return {
      // provinceId: '8794eb1f73da41d292c428dd6cd2bf88',
      provinceName: '',
      cityList: [],
      divideList: [],
      selectedCityList: [],
      selectedDivideList: [],
      checkAll: true,
      indeterminate: false,
      checkAllDivide: [],
      checkAllhhhh: [],
      cityName: '',
      divideStatus: '',
      indeterminateDivide: [],
      delayShow: true,
      data: [
      {
            "id":"8794eb1f73da41d292c428dd6cd2bf88",
            "adcode":"110000",
            "name":"北京市",
            "center":"116.405285,39.904989",
            "level":"province",
            "pid":"0",
            "isDisable":"0"
        },
        {
            "id":"53aab5134d794930b875529679b9881c",
            "adcode":"130000",
            "name":"河北省",
            "center":"114.502461,38.045474",
            "level":"province",
            "pid":"0",
            "isDisable":"0"
        }
      ]
    };
  },
  props: ['provinceId'],
  components: {
    CheckboxGroup,Checkbox
  },
  computed: {
    
  },
  created() {},
  mounted() {
    this.init(this.provinceId)
  },
  methods: {
    // getId(id) {
    //   this.provinceId = id
    // },
    init(provinceId) {
      this.delayShow = false
      this.selectedCityList = []
      this.selectedDivideList = []
      axios.get(URL + provinceId).then(res => {
        this.provinceName = res.data.data.name
        this.cityList = res.data.data.children
        this.selectedCityList = this.cityList.map(city => {
          if(city.isDisable === '0') {
            return city.name
          }
        })
        this.divideList = res.data.data.children[0].children
        this.selectedDivideList = this.divideList.map(divide => {
          if(divide.isDisable === '0') {
            return divide.name
          }
        })
        // if (this.selectedCityList.length === this.cityList.length && this.selectedDivideList.length === this.divideList.length) {
        //     this.indeterminate = false;
        //     this.checkAll = true;
        // } else if (this.selectedCityList.length > 0) {
        //     this.indeterminate = true;
        //     this.checkAll = false;
        // } else {
        //     this.indeterminate = false;
        //     this.checkAll = false;
        // }
        if (this.selectedDivideList.length === this.divideList.length) {
          if(this.selectedCityList.length === this.cityList.length) {
            this.indeterminate = false;
            this.checkAll = true;
          }else {
            this.checkAll = false;
          }
          this.cityList.forEach((item,i) => {
            // if(item.name === this.cityName) {
                this.checkAllDivide[i] = true
                this.indeterminateDivide[i] = false
              // }
          })

        } else if(this.selectedDivideList.length > 0){
            this.indeterminate = true;
            this.checkAll = false;
            this.cityList.forEach((item,i) => {
              // if(item.name === this.cityName) {
                this.checkAllDivide[i] = false
                this.indeterminateDivide[i] = true
              // }
            })
            
        }else {
          this.indeterminate = true;
          this.checkAll = false;
          this.cityList.forEach((item,i) => {
              // if(item.name === this.cityName) {
                this.checkAllDivide[i] = false
                this.indeterminateDivide[i] = false
              // }
            })
        }
        // this.cityList.forEach((city,index) => {
        //   if(city.isDisable === '1') {
        //     this.indeterminateDivide[index] = true
        //     this.checkAllDivide[index] = false
            
        //   }else {
        //     this.indeterminateDivide[index] = false
        //     this.checkAll = true
        //     this.indeterminate = false
        //   }
        // })
        // this.divideList.forEach((divide,index) => {
        //   if(divide.isDisable === '1') {
        //     this.in
        //   }
        // })
        this.delayShow = true
      })
    },
    handleCheckAll(val) {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.selectedCityList = this.cityList.map(city => city.name);
        this.selectedDivideList = this.divideList.map(divide => divide.name);
      } else {
        this.selectedCityList = [];
        this.selectedDivideList = [];
        this.cityList.forEach((city,index) => {
          this.indeterminateDivide[index] = false
        })
      }
    },
    handleCheckAllCity(val, index) {

      this.divideList = this.cityList.filter(city => city.name === val.target.value)[0].children
      
      if (val.target.checked) { //选中城市，默认选中下面区县
        this.selectedDivideList = this.divideList.map(divide => divide.name);
        this.divideList.forEach((divide,index) => {
          this.checkAllhhhh[index] = true
        })
        this.checkAllDivide[index] = true
        this.indeterminateDivide[index] = false
      } else {
        this.selectedDivideList = [];
        this.indeterminateDivide[index] = false
      }
      const sendNode = {
        "id": this.cityList.filter(city => city.name === val.target.value)[0].id,
        "level": "city",
        "pid": this.provinceId,
        "is_disable": val.target.checked ? "0" : "1"
      }
      this.$emit('send-node', sendNode)
    },
    handleCheckAllDivide(val,index) {
      const cityId = this.divideList.filter(divide => divide.name === val.target.value)[0].pid
      
      this.cityName = this.cityList.filter(city => city.id === cityId)[0].name

      const sendNode = {
        "id": this.divideList.filter(divide => divide.name === val.target.value)[0].id,
        "level": "district",
        "pid": cityId,
        "is_disable": val.target.checked ? "0" : "1"
      }
      this.$emit('send-node', sendNode)
    },
    checkAllGroupChange_city (data) {
      this.selectedCityList = data
        if (data.length === this.cityList.length && this.selectedDivideList.length === this.divideList.length) {
            this.indeterminate = false;
            this.checkAll = true;
        } else if (data.length > 0) {
            this.indeterminate = true;
            this.checkAll = false;
        } else {
            this.indeterminate = false;
            this.checkAll = false;
        }
    },
    checkAllGroupChange_divide (data) {
        this.selectedDivideList = data
        if (data.length === this.divideList.length) {
          if(this.selectedCityList.length === this.cityList.length) {
            this.indeterminate = false;
            this.checkAll = true;
          }else {
            this.checkAll = false;
          }
          this.cityList.forEach((item,i) => {
            if(item.name === this.cityName) {
                this.checkAllDivide[i] = true
                this.indeterminateDivide[i] = false
              }
          })

        } else if(data.length > 0){
            this.indeterminate = true;
            this.checkAll = false;
            this.cityList.forEach((item,i) => {
              if(item.name === this.cityName) {
                this.checkAllDivide[i] = false
                this.indeterminateDivide[i] = true
              }
            })
            
        }else {
          this.indeterminate = true;
          this.checkAll = false;
          this.cityList.forEach((item,i) => {
              if(item.name === this.cityName) {
                this.checkAllDivide[i] = false
                this.indeterminateDivide[i] = false
              }
            })
        }
    }
  },
  watch: {
    provinceId(newVal) {
      this.init(newVal)
    }
  }
};
</script>

<style scoped>
.xt-area-wrap {
  padding: 15px;
  display: flex;
  /* width: 600px; */
  border: 1px solid #eee;
}
.province,
.city,
.divide {
  flex: 1;
}
.ivu-checkbox-wrapper {
    display: block;
}
.test {
  background: red;
  width: 300px;height: 200px;
  border-radius: 10px;
}
</style>
